import { Component } from '@angular/core';


export class SkyUrlValidationDemoComponent {
  public url: string;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-url-validation-demo',
  template: `<input
  skyUrlValidation
  class="sky-form-control"
  [(ngModel)]="url"
  #input="ngModel">

<div
  class="sky-error-label"
  *ngIf="input.errors && input.errors.skyUrl && (input.dirty && input.touched)">
  <span
    [hidden]="!input.errors.skyUrl.invalid">
    Please enter valid url with format http(s)://site.domain
  </span>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
